import { useWorkOrderControllerGetWorkOrder } from '@/generated/api/work-order.ts';
import { WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS } from '../autoRefresh.ts';

export default function useWorkOrder(workOrderId?: string) {
  return useWorkOrderControllerGetWorkOrder(workOrderId ?? '', {
    query: {
      ...WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS,
      enabled: Boolean(workOrderId),
    },
  });
}
